import { render, staticRenderFns } from "./QrcodeVoteResult.vue?vue&type=template&id=dc42ebf8&scoped=true&"
import script from "./QrcodeVoteResult.vue?vue&type=script&lang=js&"
export * from "./QrcodeVoteResult.vue?vue&type=script&lang=js&"
import style0 from "./QrcodeVoteResult.vue?vue&type=style&index=0&id=dc42ebf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc42ebf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
